/** Phase: GroupList + GroupDetail — ko/en/vi/ru (createForm excluded; see i18nPhaseGroupsCreate) */

const myGroups = {
  pendingSection: ['승인 대기', 'Pending approval', 'Chờ duyệt', 'Ожидает одобрения'],
  pendingBadge: ['대기 중', 'Pending', 'Đang chờ', 'Ожидание'],
  organizerBadge: ['운영자', 'Organizer', 'Quản trị', 'Организатор'],
};

const root = {
  title: ['모임', 'Groups', 'Nhóm', 'Группы'],
  searchPlaceholder: ['모임 검색', 'Search groups', 'Tìm nhóm', 'Поиск групп'],
  create: ['+ 만들기', '+ Create', '+ Tạo nhóm', '+ Создать'],
  loadFailed: [
    '모임 목록을 불러오지 못했습니다.',
    'Could not load groups.',
    'Không tải được danh sách nhóm.',
    'Не удалось загрузить группы.',
  ],
  empty: [
    '이 지역에 표시할 모임이 없습니다.',
    'No groups in this area.',
    'Chưa có nhóm nào trong khu vực này.',
    'В этом районе пока нет групп.',
  ],
  loginToJoin: [
    '로그인 후 가입할 수 있습니다.',
    'Sign in to join.',
    'Đăng nhập để tham gia.',
    'Войдите, чтобы вступить.',
  ],
  join: ['가입하기', 'Join', 'Tham gia', 'Вступить'],
  joining: ['처리 중…', 'Joining…', 'Đang xử lý…', 'Обработка…'],
  joinSuccess: [
    '모임에 가입했습니다.',
    'You joined the group.',
    'Bạn đã tham gia nhóm.',
    'Вы вступили в группу.',
  ],
  joinFailed: ['가입에 실패했습니다.', 'Could not join.', 'Không tham gia được.', 'Не удалось вступить.'],
  alreadyMember: [
    '이미 가입한 모임입니다.',
    'You are already a member.',
    'Bạn đã là thành viên.',
    'Вы уже в группе.',
  ],
  groupFull: ['정원이 가득 찼습니다.', 'This group is full.', 'Nhóm đã đủ thành viên.', 'Группа заполнена.'],
  leave: ['탈퇴', 'Leave', 'Rời nhóm', 'Выйти'],
  leaveSuccess: [
    '모임에서 탈퇴했습니다.',
    'You left the group.',
    'Bạn đã rời nhóm.',
    'Вы вышли из группы.',
  ],
  leaveFailed: ['탈퇴에 실패했습니다.', 'Could not leave.', 'Không rời được nhóm.', 'Не удалось выйти.'],
  deleteConfirmMessage: [
    '모임을 해체하면 되돌릴 수 없어요. 정말 해체하시겠어요?',
    'Disbanding cannot be undone. Are you sure?',
    'Giải tán nhóm không thể hoàn tác. Bạn có chắc không?',
    'Роспуск нельзя отменить. Вы уверены?',
  ],
  deleteSuccess: [
    '모임이 해체됐어요',
    'Group disbanded',
    'Đã giải tán nhóm',
    'Группа распущена',
  ],
  deleteError: [
    '해체 처리에 실패했어요',
    'Could not disband the group',
    'Không giải tán được nhóm',
    'Не удалось распустить группу',
  ],
  deleting: ['처리 중...', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  notFound: ['모임을 찾을 수 없습니다.', 'Group not found.', 'Không tìm thấy nhóm.', 'Группа не найдена.'],
  regionUnset: ['지역 미설정', 'Region not set', 'Chưa chọn khu vực', 'Регион не указан'],
  memberCount: ['멤버 {count}명', '{count} members', '{count} thành viên', '{count} участников'],
  maxMembers: ['최대 {max}명', 'max {max}', 'tối đa {max}', 'макс. {max}'],
  filterAll: ['전체', 'All', 'Tất cả', 'Все'],
  filterFree: ['무료', 'Free', 'Miễn phí', 'Бесплатно'],
  filterPaid: ['유료', 'Paid', 'Trả phí', 'Платно'],
  paidFilterLabel: ['무료·유료 필터', 'Free / paid filter', 'Lọc miễn phí / trả phí', 'Фильтр: бесплатно / платно'],
  escrowNotice: [
    '가입비는 플랫폼이 보관하며, 첫 모임 이벤트 완료 후 운영자에게 정산됩니다.',
    'Your join fee is held by the platform and paid to the organizer after the first event is completed.',
    'Phí tham gia được giữ trên nền tảng và chuyển cho quản trị sau sự kiện đầu tiên.',
    'Взнос удерживается платформой и переводится организатору после первого мероприятия.',
  ],
  joinFeeConfirm: [
    '가입비를 포인트로 결제합니다.',
    'You will pay the join fee in points.',
    'Bạn sẽ trả phí tham gia bằng điểm.',
    'Взнос списывается в баллах.',
  ],
  joinFeeLabel: ['가입비', 'Join fee', 'Phí tham gia', 'Взнос'],
  myPoints: ['내 보유 포인트', 'Your balance', 'Số dư của bạn', 'Ваш баланс'],
  chargePoints: ['포인트 충전하기', 'Top up points', 'Nạp điểm', 'Пополнить баллы'],
  insufficientPoints: [
    '포인트가 부족합니다. 충전 후 가입해 주세요.',
    'Not enough points. Please top up and try again.',
    'Không đủ điểm. Vui lòng nạp thêm rồi tham gia.',
    'Недостаточно баллов. Пополните и попробуйте снова.',
  ],
  pendingApproval: ['승인 대기 중', 'Pending approval', 'Chờ duyệt', 'Ожидает одобрения'],
  approvalWaiting: ['승인 대기 중', 'Awaiting approval', 'Đang chờ duyệt', 'Ожидание одобрения'],
  groupUnavailable: [
    '참여할 수 없는 모임입니다.',
    'This group is not available.',
    'Nhóm không khả dụng.',
    'Группа недоступна.',
  ],
  kickMember: ['강퇴', 'Remove', 'Loại bỏ', 'Исключить'],
  kickConfirm: ['이 멤버를 강퇴할까요?', 'Remove this member?', 'Loại thành viên này?', 'Исключить участника?'],
  kickSuccess: [
    '멤버를 강퇴했습니다.',
    'Member removed.',
    'Đã loại thành viên.',
    'Участник исключён.',
  ],
  promoteMember: ['운영자 지정', 'Make moderator', 'Chỉ định quản trị', 'Назначить модератором'],
  promoteSuccess: [
    '운영자로 지정했습니다.',
    'Moderator assigned.',
    'Đã chỉ định quản trị.',
    'Модератор назначен.',
  ],
  approve: ['승인', 'Approve', 'Duyệt', 'Одобрить'],
  reject: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  approveSuccess: [
    '가입을 승인했습니다.',
    'Member approved.',
    'Đã duyệt tham gia.',
    'Заявка одобрена.',
  ],
  rejectSuccess: [
    '가입을 거절했습니다.',
    'Request rejected.',
    'Đã từ chối tham gia.',
    'Заявка отклонена.',
  ],
  actionFailed: ['처리에 실패했습니다.', 'Action failed.', 'Không xử lý được.', 'Не удалось выполнить.'],
  pendingSection: ['받은 요청함', 'Join requests', 'Yêu cầu tham gia', 'Заявки на вступление'],
  joinRequestSection: ['가입 요청', 'Join requests', 'Yêu cầu tham gia', 'Заявки на вступление'],
  noPendingRequests: [
    '대기 중인 요청 없음',
    'No pending requests.',
    'Không có yêu cầu đang chờ.',
    'Нет ожидающих заявок.',
  ],
  recurringEvent: ['정기 모임', 'Recurring meetup', 'Gặp định kỳ', 'Регулярные встречи'],
  sponsoredBusiness: ['제휴 업체', 'Partner business', 'Đối tác', 'Партнёр'],
  sponsoredPlaceholder: [
    '제휴 업체 정보가 곧 연결됩니다.',
    'Partner listings will appear here soon.',
    'Thông tin đối tác sẽ sớm hiển thị tại đây.',
    'Информация о партнёрах скоро появится здесь.',
  ],
  translatePost: ['번역하기', 'Translate', 'Dịch', 'Перевести'],
  postPlaceholder: [
    '모임에 글 남기기',
    'Write to the group',
    'Viết trong nhóm',
    'Написать в группе',
  ],
  post: ['게시', 'Post', 'Đăng', 'Опубликовать'],
  posting: ['등록 중…', 'Posting…', 'Đang đăng…', 'Публикация…'],
  postSuccess: ['게시했습니다.', 'Posted.', 'Đã đăng.', 'Опубликовано.'],
  postFailed: ['게시에 실패했습니다.', 'Could not post.', 'Không đăng được.', 'Не удалось опубликовать.'],
  boardMembersOnly: [
    '게시판은 멤버만 이용할 수 있습니다. 가입 후 이용해 주세요.',
    'Only members can use the board. Join to participate.',
    'Chỉ thành viên mới dùng được bảng tin. Hãy tham gia nhóm.',
    'Доска только для участников. Вступите в группу.',
  ],
  notice: ['공지', 'Notice', 'Thông báo', 'Объявление'],
  memberFallback: ['회원', 'Member', 'Thành viên', 'Участник'],
  noPosts: ['게시글이 없습니다.', 'No posts yet.', 'Chưa có bài viết.', 'Пока нет записей.'],
  createEvent: ['번개 만들기', 'Create flash meetup', 'Tạo hẹn nhanh', 'Создать быструю встречу'],
  upcomingEvents: ['다가오는 번개', 'Upcoming meetups', 'Sắp diễn ra', 'Предстоящие'],
  pastEvents: ['지난 번개', 'Past meetups', 'Đã qua', 'Прошедшие'],
  noUpcomingEvents: [
    '예정된 번개가 없습니다.',
    'No upcoming meetups.',
    'Chưa có hẹn nhanh sắp tới.',
    'Нет предстоящих встреч.',
  ],
  noPastEvents: [
    '지난 번개가 없습니다.',
    'No past meetups.',
    'Chưa có hẹn nhanh đã qua.',
    'Нет прошедших встреч.',
  ],
  eventTitlePh: [
    '번개 제목 (예: 오늘 저녁 치맥)',
    'Title (e.g. Drinks tonight)',
    'Tiêu đề (vd: Ăn tối tối nay)',
    'Название (напр. Ужин сегодня)',
  ],
  eventLocationPh: ['장소', 'Location', 'Địa điểm', 'Место'],
  eventMaxParticipantsPh: ['인원 제한 (선택)', 'Max participants (optional)', 'Giới hạn người (tùy chọn)', 'Лимит участников (необяз.)'],
  eventMoreFields: ['설명·비용 추가', 'More fields', 'Thêm mô tả & phí', 'Ещё поля'],
  eventDescriptionPh: [
    '설명 / 준비물 (선택)',
    'Description / what to bring (optional)',
    'Mô tả / đồ cần mang (tùy chọn)',
    'Описание / что взять с собой (необяз.)',
  ],
  eventFeePh: ['참가비 포인트 (선택)', 'Fee in points (optional)', 'Phí điểm (tùy chọn)', 'Взнос в баллах (необяз.)'],
  eventSubmit: ['번개 만들기', 'Create meetup', 'Tạo hẹn nhanh', 'Создать встречу'],
  eventCreated: ['번개가 등록됐어요', 'Meetup created', 'Đã tạo hẹn nhanh', 'Встреча создана'],
  eventCreateError: ['번개 등록에 실패했어요', 'Could not create meetup', 'Không tạo được hẹn nhanh', 'Не удалось создать встречу'],
  eventRequiredFields: ['제목과 일시는 필수예요', 'Title and time are required', 'Cần tiêu đề và thời gian', 'Нужны название и время'],
  eventJoin: ['참가하기', 'Join', 'Tham gia', 'Участвовать'],
  eventLeave: ['참가 취소', 'Cancel RSVP', 'Hủy tham gia', 'Отменить участие'],
  eventParticipantsSuffix: ['명 참가', ' joined', ' người tham gia', ' участников'],
  eventFeeLabel: ['참가비 {points}P', 'Fee {points}P', 'Phí tham gia {points}P', 'Взнос {points}P'],
  eventFeePrefix: ['참가비', 'Fee', 'Phí tham gia', 'Взнос'],
  manageTitle: ['모임 관리', 'Manage group', 'Quản lý nhóm', 'Управление группой'],
  searchMembers: ['멤버 검색', 'Search members', 'Tìm thành viên', 'Поиск участников'],
  membersUnit: ['명', '', ' người', ' чел.'],
  noMembersFound: ['검색 결과가 없습니다.', 'No members found.', 'Không có thành viên.', 'Участники не найдены.'],
  manageForbidden: ['모임 관리 권한이 없습니다.', 'You cannot manage this group.', 'Bạn không có quyền quản lý nhóm này.', 'Нет прав на управление группой.'],
  eventViewParticipants: ['참가자 보기', 'View participants', 'Xem người tham gia', 'Участники'],
  eventChat: ['번개 채팅', 'Event chat', 'Chat sự kiện', 'Чат встречи'],
  eventChatError: ['채팅방을 열 수 없어요', 'Could not open chat', 'Không mở được phòng chat', 'Не удалось открыть чат'],
  moreOptions: ['더보기', 'More options', 'Tùy chọn thêm', 'Ещё'],
  eventJoinErrorGeneric: ['참가 처리에 실패했어요', 'Could not update RSVP', 'Không cập nhật được tham gia', 'Не удалось обновить участие'],
  creating: ['등록 중…', 'Creating…', 'Đang tạo…', 'Создание…'],
  noDescription: ['소개가 없습니다.', 'No description.', 'Chưa có mô tả.', 'Нет описания.'],
  rules: ['모임 규칙', 'Group rules', 'Quy tắc nhóm', 'Правила группы'],
  schedule: ['정기 일정', 'Regular schedule', 'Lịch định kỳ', 'Расписание'],
  createdAt: ['개설일', 'Created', 'Ngày tạo', 'Создано'],
  revenueTotal: [
    '총 수입 (운영자 몫)',
    'Total earnings (organizer)',
    'Tổng thu nhập (quản trị)',
    'Общий доход (организатор)',
  ],
  revenueMonth: ['이번 달', 'This month', 'Tháng này', 'Этот месяц'],
  requestPayout: ['정산 신청', 'Request payout', 'Yêu cầu thanh toán', 'Запросить выплату'],
  payoutSoon: [
    '정산 신청은 준비 중입니다.',
    'Payout requests are coming soon.',
    'Tính năng thanh toán sắp có.',
    'Выплаты скоро будут доступны.',
  ],
  noRevenue: ['수익 내역이 없습니다.', 'No revenue yet.', 'Chưa có doanh thu.', 'Пока нет дохода.'],
  contactBtn: ['💬 연락하기', '💬 Contact', '💬 Liên hệ', '💬 Связаться'],
  contactKakao: ['카카오톡', 'KakaoTalk', 'Kakao chat', 'Kakao чат'],
  contactWhatsapp: ['왓츠앱', 'WhatsApp', 'WhatsApp (SĐT)', 'Ватсап'],
  contactZalo: ['잘로', 'Zalo', 'Zalo (SĐT)', 'Зало'],
  connecting: ['연결 중...', 'Connecting…', 'Đang kết nối…', 'Подключение…'],
  noContactRegistered: [
    '연락처를 등록해주세요.',
    'No contact info on file.',
    'Chưa có thông tin liên hệ.',
    'Контакт не указан.',
  ],
  noContactForOwner: [
    '연락처가 없습니다. 모임 생성/수정에서 등록해 주세요.',
    'No contact channel is set. Add one in group create/edit.',
    'Chưa có kênh liên hệ. Hãy thêm khi tạo/chỉnh sửa nhóm.',
    'Канал связи не указан. Добавьте его при создании/редактировании группы.',
  ],
  noContactForMembers: [
    '아직 운영자가 연락처를 등록하지 않았습니다.',
    'Organizer contact is not registered yet.',
    'Quản trị viên chưa đăng ký liên hệ.',
    'Контакт организатора пока не указан.',
  ],
  contactSection: ['연락 채널', 'Contact channels', 'Kênh liên hệ', 'Каналы связи'],
  chatRoomError: [
    '채팅방을 열 수 없습니다',
    'Could not open chat room',
    'Không thể mở phòng chat',
    'Не удалось открыть чат',
  ],
};

const actionBtn = {
  manage: ['관리', 'Manage', 'Quản lý', 'Управлять'],
  enter: ['입장', 'Enter', 'Vào nhóm', 'Войти'],
  join: ['가입하기', 'Join', 'Tham gia', 'Вступить'],
  apply: ['가입 신청', 'Request to join', 'Xin tham gia', 'Подать заявку'],
  leave: ['탈퇴', 'Leave', 'Rời nhóm', 'Выйти'],
  disband: ['모임 해체', 'Disband group', 'Giải tán nhóm', 'Распустить группу'],
  disbandConfirm: ['해체하기', 'Disband', 'Giải tán', 'Распустить'],
  inAppChat: ['인앱채팅', 'In-app Chat', 'Trò chuyện trong ứng dụng', 'Чат в приложении'],
  externalChat: ['외부채팅', 'External Chat', 'Trò chuyện bên ngoài', 'Внешний чат'],
};

const messenger = {
  kakao: ['카카오톡', 'KakaoTalk', 'KakaoTalk (chat)', 'КакаоТок'],
  kakaoPh: ['카카오 오픈채팅 ID 또는 링크', 'Kakao open-chat ID or link', 'ID hoặc liên kết Kakao open-chat', 'ID или ссылка Kakao open-chat'],
  whatsapp: ['WhatsApp', 'WhatsApp', 'WhatsApp (chat)', 'Ватсап (чат)'],
  whatsappPh: ['국가코드 포함 번호', 'Number with country code', 'Số kèm mã quốc gia', 'Номер с кодом страны'],
  zalo: ['Zalo', 'Zalo', 'Zalo (chat)', 'Зало (чат)'],
  zaloPh: ['Zalo 번호 또는 링크', 'Zalo number or link', 'Số hoặc liên kết Zalo', 'Номер или ссылка Zalo'],
  telegram: ['Telegram', 'Telegram', 'Telegram (chat)', 'Телеграм'],
  telegramPh: ['@handle 또는 t.me 링크', '@handle or t.me link', '@handle hoặc liên kết t.me', '@ник или ссылка t.me'],
  line: ['LINE', 'LINE', 'LINE (chat)', 'Лайн (чат)'],
  linePh: ['LINE ID', 'LINE ID', 'ID LINE', 'ID LINE'],
  wechat: ['WeChat', 'WeChat', 'WeChat (chat)', 'Вичат'],
  wechatPh: ['WeChat ID', 'WeChat ID', 'ID WeChat', 'ID WeChat'],
  messenger: ['Messenger', 'Messenger', 'Facebook Messenger', 'Мессенджер Facebook'],
  messengerPh: ['m.me 링크', 'm.me link', 'Liên kết m.me', 'Ссылка m.me'],
  instagram: ['Instagram', 'Instagram', 'Instagram (DM)', 'Инстаграм'],
  instagramPh: ['@handle', '@handle', '@tên người dùng', '@ник'],
  signal: ['Signal', 'Signal', 'Signal (chat)', 'Сигнал (чат)'],
  signalPh: ['Signal 번호/링크', 'Signal number/link', 'Số/liên kết Signal', 'Номер/ссылка Signal'],
};

const role = {
  organizer: ['운영자', 'Organizer', 'Quản trị', 'Организатор'],
  moderator: ['매니저', 'Moderator', 'Quản trị viên', 'Модератор'],
  member: ['멤버', 'Member', 'Thành viên', 'Участник'],
};

const cat = {
  all: ['전체', 'All', 'Tất cả', 'Все'],
  sports: ['운동/스포츠', 'Sports', 'Thể thao', 'Спорт'],
  learning: ['언어교환', 'Language exchange', 'Trao đổi ngôn ngữ', 'Языковой обмен'],
  food: ['맛집', 'Food', 'Ẩm thực', 'Еда'],
  support: ['종교/신앙', 'Faith', 'Tín ngưỡng', 'Вера'],
  general: ['일반', 'General', 'Chung', 'Общее'],
  jobs: ['비즈니스', 'Business', 'Kinh doanh', 'Бизнес'],
  parenting: ['육아', 'Parenting', 'Nuôi con', 'Родительство'],
  gaming: ['게임', 'Gaming', 'Game', 'Игры'],
  culture: ['문화/예술', 'Culture', 'Văn hóa', 'Культура'],
};

const type = {
  general: ['일반', 'General', 'Chung', 'Общее'],
  sports: ['운동/스포츠', 'Sports', 'Thể thao', 'Спорт'],
  learning: ['스터디/학습', 'Learning', 'Học tập', 'Обучение'],
  culture: ['문화/예술', 'Culture', 'Văn hóa', 'Культура'],
  support: ['종교/신앙', 'Faith', 'Tín ngưỡng', 'Вера'],
  jobs: ['구인구직', 'Jobs', 'Việc làm', 'Работа'],
  parenting: ['육아/가족', 'Parenting', 'Gia đình', 'Семья'],
  buy_sell: ['공동구매', 'Group buy', 'Mua chung', 'Совместная покупка'],
  gaming: ['게임', 'Gaming', 'Game', 'Игры'],
  flash: ['번개', 'Flash meetup', 'Hẹn nhanh', 'Быстрая встреча'],
};

const privacy = {
  public: ['공개', 'Public', 'Công khai', 'Открытая'],
  private: ['비공개', 'Private', 'Riêng tư', 'Закрытая'],
  secret: ['비밀', 'Secret', 'Bí mật', 'Секретная'],
};

const badge = {
  free: ['무료', 'Free', 'Miễn phí', 'Бесплатно'],
  paid: ['유료', 'Paid', 'Trả phí', 'Платно'],
  diamond: ['다이아', 'Diamond', 'Kim cương', 'Бриллиант'],
  gold: ['골드', 'Gold', 'Vàng', 'Золото'],
  silver: ['실버', 'Silver', 'Bạc', 'Серебро'],
  bronze: ['브론즈', 'Bronze', 'Đồng', 'Бронза'],
};

const tab = {
  board: ['게시판', 'Board', 'Bảng tin', 'Лента'],
  members: ['멤버', 'Members', 'Thành viên', 'Участники'],
  events: ['이벤트', 'Events', 'Sự kiện', 'События'],
  info: ['정보', 'Info', 'Thông tin', 'Инфо'],
  revenue: ['수익', 'Revenue', 'Doanh thu', 'Доход'],
};

const eventJoinError = {
  event_full: ['정원이 가득 찼어요', 'This meetup is full', 'Đã đủ người', 'Мест нет'],
  not_a_group_member: [
    '모임 멤버만 참가할 수 있어요',
    'Only group members can join',
    'Chỉ thành viên nhóm mới tham gia được',
    'Только участники группы могут присоединиться',
  ],
};

const mna = {
  title: ['모임 M&A', 'Group M&A', 'Sáp nhập nhóm', 'M&A групп'],
  desc: [
    '다른 모임과 합병하거나 운영권을 양도할 수 있습니다.',
    'Merge with another group or transfer ownership.',
    'Có thể sáp nhập hoặc chuyển quyền quản lý nhóm.',
    'Можно объединить группы или передать управление.',
  ],
  merge: [
    '다른 모임과 합병하기',
    'Merge with another group',
    'Sáp nhập với nhóm khác',
    'Объединить с другой группой',
  ],
  transfer: [
    '운영권 양도 (판매)',
    'Transfer ownership (sale)',
    'Chuyển quyền quản lý (bán)',
    'Передать управление (продажа)',
  ],
  minMembersNotice: [
    '현재 {{count}}명 · M&A는 {{required}}명 이상만 가능합니다',
    '{{count}} members · M&A requires {{required}}+ active members',
    'Hiện {{count}} thành viên · M&A cần từ {{required}} thành viên',
    '{{count}} участников · M&A доступно от {{required}}',
  ],
  voteTitle: ['합병 투표', 'Merge vote', 'Bỏ phiếu sáp nhập', 'Голосование за слияние'],
  voteDesc: [
    '우리 모임이 합병을 진행합니다. 동의하십니까?',
    'Our group is voting on a merge. Do you agree?',
    'Nhóm đang bỏ phiếu sáp nhập. Bạn đồng ý?',
    'Группа голосует за слияние. Вы согласны?',
  ],
  voteYes: ['찬성', 'Yes', 'Đồng ý', 'Да'],
  voteNo: ['반대', 'No', 'Không', 'Нет'],
  voteWarning: [
    '합병 확정 후 새 모임 참여 여부를 직접 선택할 수 있습니다.',
    'After merge approval you can choose whether to stay in the new group.',
    'Sau khi sáp nhập bạn có thể chọn ở lại nhóm mới hay không.',
    'После слияния вы сможете выбрать, остаться в новой группе.',
  ],
  voteDeadline: [
    '투표 마감 D-{{days}}일',
    'Vote ends in {{days}} days',
    'Bỏ phiếu kết thúc sau {{days}} ngày',
    'Голосование через {{days}} дн.',
  ],
  voteStats: [
    '찬성 {{yes}}% · 반대 {{no}}%',
    'Yes {{yes}}% · No {{no}}%',
    'Đồng ý {{yes}}% · Không {{no}}%',
    'Да {{yes}}% · Нет {{no}}%',
  ],
  escrowNotice: [
    '거래 대금은 14일간 에스크로 보관 후 정산됩니다',
    'Funds are held in escrow for 14 days before payout',
    'Tiền được giữ 14 ngày trước khi thanh toán',
    'Средства удерживаются 14 дней до выплаты',
  ],
  adminReview: [
    '고액 거래는 어드민 검토 후 진행됩니다 (50,000P 이상)',
    'High-value deals need admin review (50,000P+)',
    'Giao dịch lớn cần duyệt quản trị (từ 50.000P)',
    'Крупные сделки требуют проверки (от 50 000P)',
  ],
  feePct: ['플랫폼 수수료 15%', 'Platform fee 15%', 'Phí nền tảng 15%', 'Комиссия 15%'],
  paidOnly: [
    '유료 모임만 합병/양도 가능합니다',
    'Paid groups only',
    'Chỉ nhóm trả phí mới được sáp nhập/chuyển',
    'Только платные группы',
  ],
  paidDurationNotice: [
    '유료 유지 {{remaining}}개월 후 양도 가능합니다',
    'Transfer available after {{remaining}} more months as paid',
    'Chuyển quyền sau {{remaining}} tháng trả phí',
    'Передача через {{remaining}} мес. платного статуса',
  ],
  insufficientManagers: [
    '매니저 {{count}}명 · 3명 이상 임명 후 신청 가능',
    '{{count}} managers · appoint 3+ before applying',
    '{{count}} quản trị · cần ít nhất 3 người',
    '{{count}} модераторов · назначьте 3+',
  ],
  managerApprovalTitle: [
    '운영진 사전 동의',
    'Manager pre-approval',
    'Đồng ý trước của quản trị',
    'Предварительное одобрение',
  ],
  managerApprovalDesc: [
    '{{name}} 모임의 합병/양도 신청에 동의하시겠습니까?',
    'Approve M&A request for {{name}}?',
    'Đồng ý yêu cầu M&A cho {{name}}?',
    'Одобрить M&A для {{name}}?',
  ],
  managerApprovalExpiry: [
    '{{days}}일 내 응답 필요',
    'Respond within {{days}} days',
    'Trả lời trong {{days}} ngày',
    'Ответьте в течение {{days}} дн.',
  ],
  managerApproved: ['동의하기', 'Approve', 'Đồng ý', 'Одобрить'],
  managerRejected: ['거절하기', 'Reject', 'Từ chối', 'Отклонить'],
  managerRejectHint: [
    '거절 시 신청이 즉시 취소됩니다',
    'Rejecting cancels the request immediately',
    'Từ chối sẽ hủy yêu cầu ngay',
    'Отклонение отменяет заявку',
  ],
  submit: ['신청하기', 'Submit request', 'Gửi yêu cầu', 'Отправить'],
  submitSuccess: [
    'M&A 신청이 접수되었습니다. 운영진 동의를 기다립니다.',
    'M&A request submitted. Awaiting manager approvals.',
    'Đã gửi yêu cầu M&A. Chờ quản trị đồng ý.',
    'Заявка M&A отправлена. Ожидается одобрение.',
  ],
  submitFailed: [
    '신청에 실패했습니다.',
    'Could not submit request',
    'Không gửi được yêu cầu',
    'Не удалось отправить заявку',
  ],
  eligible: [
    '신청 자격을 충족합니다',
    'Eligibility requirements met',
    'Đủ điều kiện đăng ký',
    'Требования выполнены',
  ],
  targetGroup: ['합병 대상 모임', 'Target group', 'Nhóm mục tiêu', 'Целевая группа'],
  pickTarget: ['대상 모임 선택', 'Select target', 'Chọn nhóm', 'Выбрать группу'],
  newNameOptional: [
    '합병 후 모임명 (선택)',
    'New group name (optional)',
    'Tên nhóm sau sáp nhập (tùy chọn)',
    'Название после слияния (необяз.)',
  ],
  priceLabel: [
    '양도 가격 (포인트)',
    'Transfer price (points)',
    'Giá chuyển nhượng (điểm)',
    'Цена передачи (баллы)',
  ],
  buyerIdOptional: [
    '구매자 ID (선택)',
    'Buyer user ID (optional)',
    'ID người mua (tùy chọn)',
    'ID покупателя (необяз.)',
  ],
  votingInProgress: [
    '합병 투표가 진행 중입니다',
    'Merge vote in progress',
    'Đang bỏ phiếu sáp nhập',
    'Идёт голосование',
  ],
  voteRecorded: ['투표가 반영되었습니다.', 'Vote recorded', 'Đã ghi nhận phiếu', 'Голос учтён'],
  voteFailed: ['투표에 실패했습니다.', 'Vote failed', 'Bỏ phiếu thất bại', 'Не удалось проголосовать'],
  mergeChoiceTitle: [
    '합병이 확정되었습니다',
    'Merge approved',
    'Sáp nhập đã được duyệt',
    'Слияние одобрено',
  ],
  mergeChoiceDesc: [
    '새 모임에 계속 참여하시겠습니까?',
    'Stay in the merged group?',
    'Tiếp tục ở nhóm mới?',
    'Остаться в объединённой группе?',
  ],
  mergeChoiceStay: ['새 모임 유지', 'Stay', 'Ở lại', 'Остаться'],
  mergeChoiceLeave: ['탈퇴하기', 'Leave', 'Rời nhóm', 'Выйти'],
  mergeChoiceExpiry: [
    '{{days}}일 내 선택하지 않으면 자동으로 새 모임에 유지됩니다.',
    'If you do not choose within {{days}} days you will remain in the new group.',
    'Nếu không chọn trong {{days}} ngày, bạn sẽ ở lại nhóm mới.',
    'Если не выбрать за {{days}} дн., вы останетесь в новой группе.',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  const rootPicked = pick(root, langIndex);
  const { contactBtn, contactKakao, contactWhatsapp, contactZalo, contactSection, ...rootRest } = rootPicked;
  return {
    groups: {
      ...rootRest,
      btn: pick(actionBtn, langIndex),
      messenger: pick(messenger, langIndex),
      contact: {
        btn: contactBtn,
        kakao: contactKakao,
        whatsapp: contactWhatsapp,
        zalo: contactZalo,
        section: contactSection,
      },
      myGroups: pick(myGroups, langIndex),
      cat: pick(cat, langIndex),
      type: pick(type, langIndex),
      privacy: pick(privacy, langIndex),
      badge: pick(badge, langIndex),
      tab: pick(tab, langIndex),
      role: pick(role, langIndex),
      eventJoinError: pick(eventJoinError, langIndex),
      mna: pick(mna, langIndex),
    },
  };
}

export const phaseGroupsListDetailKo = buildLang(0);
export const phaseGroupsListDetailEn = buildLang(1);
export const phaseGroupsListDetailVi = buildLang(2);
export const phaseGroupsListDetailRu = buildLang(3);
